/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GCPBucketLocationType } from './gCPBucketLocationType';


export interface GcpBucketsResponse { 
    /**
     * The bucket id
     */
    id: string;
    /**
     * Name of the bucket
     */
    name: string;
    /**
     * Geographic location where the bucket resides
     */
    location: string;
    location_type: GCPBucketLocationType;
    /**
     * Timestamp when the bucket was created
     */
    create_time: Date;
    /**
     * Timestamp when the bucket was last updated
     */
    update_time: Date;
}
export namespace GcpBucketsResponse {
}


